import { createSlice } from "@reduxjs/toolkit";
import { dispatch } from "../store";
import axios from 'axios';


// Redux

// ----------------------------------------------------------------------

let initialState = {
    searchTerm: "",
    inputValue: "",
    statusFilter: "Unpaid",
    typeFilter: "All",
    dueFilter: "All",
    sortColumn: "",
    sortDirection: "asc",
    currentPage: 1,
    scrollPos: 0,
    LastStatus: "Open",
    invoiceList: { 'rows': [] },

    invoiceNum: null,
    invbillingforecast: [],
    invSummaryCardData: {},
    invSummaryTableData: {},
    invLogbookData: {},
    statusActivityMap: [],
    isinvoiceListLoading: false,
    isinvSummaryCardLoading: false,
    isinvSummaryTableLoading: false,
    isinvoiceLogBookLoading: true,
    isinvSummaryCardLoading: false,
    isinvSummaryTableLoading: false,
    error: null,
    errorInvNum: null,
    showSuccess: false,
};

export const slice = createSlice({
    name: "invoice",
    initialState,
    reducers: {
        // set filter values in redux
        setInvoiceSummaryCards(state, action) {
            state.invSummaryCardData = action.payload;
            state.isinvSummaryCardLoading = false;
        },

        setInvoiceSummaryTable(state, action) {
            state.invSummaryTableData = action.payload;
            state.isinvSummaryTableLoading = false;
        },

        setInvoiceLogbookData(state, action) {
            state.invLogbookData = action.payload;
        },

        setInvoiceLogbookFilters(state, action) {
            state.statusActivityMap = action.payload;
        },

        setInvoiceList(state, action) {
            state.invoiceList = action.payload;
            state.isinvoiceListLoading = false;
        },

        setBillingForecast(state, action) {
            state.invbillingforecast = action.payload;
        },

        setInvoiceNum(state, action) {
            state.invoiceNum = action.payload;
        },

        setSearchTerm(state, action) {
            state.searchTerm = action.payload;
        },

        setinputValue(state, action) {
            state.inputValue = action.payload;
        },

        setStatusFilter(state, action) {
            state.statusFilter = action.payload;
        },

        setTypeFilter(state, action) {
            state.typeFilter = action.payload;
        },

        setDueFilter(state, action) {
            state.dueFilter = action.payload;
        },

        setSortDirection(state, action) {
            state.sortDirection = action.payload;
        },

        setSortColumn(state, action) {
            state.sortColumn = action.payload;
        },

        setCurrentPage(state, action) {
            state.currentPage = action.payload;
        },

        setScrollPos(state, action) {
            state.scrollPos = action.payload;
        },

        setLastStatus(state, action) {
            state.LastStatus = action.payload;
        },

        setInvoiceListLoading(state, action) {
            state.isinvoiceListLoading = action.payload;
        },

        setInvSummaryCardLoading(state, action) {
            state.isinvSummaryCardLoading = action.payload;
        },

        setInvSummaryTableLoading(state, action) {
            state.isinvSummaryTableLoading = action.payload;
        },

        setInvLogbookLoading(state, action) {
            state.isinvoiceLogBookLoading = action.payload;
        },

        setShowSuccess(state, action) {
            state.showSuccess = action.payload;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isinvSummaryTableLoading = false;
            state.error = action.payload;
        },

        hasErrorNum(state, action) {
            state.errorInvNum = action.payload;
        }

    },
});

export const {
    setinputValue,
    setCurrentPage,
    setLastStatus,
    setSortColumn,
    setSortDirection,
    setPaginationLoading,
    setSearchTerm,
    setStatusFilter,
    setTypeFilter,
    setDueFilter,
    setInvoiceList,
    setShowSuccess,
    hasError,
} = slice.actions;

export function getInvoiceList(statusFilter, statusType, statusDue, searchTerm, sortColumn, sortDirection, rowsPerPage, page) {
    const API_URL = process.env.REACT_APP_API_URL;
    return async () => {
        dispatch(slice.actions.setInvoiceListLoading(true));
        try {
            // Construct the query string
            const queryParams = new URLSearchParams({
                statusFilter,
                statusType,
                statusDue,
                page,
                rowsPerPage,
                searchTerm,
                sortColumn,
                sortDirection
            }).toString();

            const response = await axios.get(`${API_URL}/api/invoice/list/all?${queryParams}`);
            dispatch(slice.actions.setInvoiceList(response.data));
        } catch (error) {
            console.error(error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getInvSummaryTable(time_frame) {
    const API_URL = process.env.REACT_APP_API_URL;
    return async (dispatch) => {
        dispatch(slice.actions.setInvSummaryTableLoading(true));
        try {
            const response = await axios.get(`${API_URL}/api/invoicing/summary/table`, {
                params: { time_frame }
            });
            dispatch(slice.actions.setInvoiceSummaryTable(response.data));
        } catch (error) {
            console.error(error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getInvSummaryCards(time_frame) {
    const API_URL = process.env.REACT_APP_API_URL;
    return async (dispatch) => {
        dispatch(slice.actions.setInvSummaryCardLoading(true));
        try {
            const response = await axios.get(`${API_URL}/api/invoicing/summary/cards`, {
                params: { time_frame }
            });
            dispatch(slice.actions.setInvoiceSummaryCards(response.data.data));
        } catch (error) {
            console.error(error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getLogBook() {
    const API_URL = process.env.REACT_APP_API_URL;
    return async () => {
        dispatch(slice.actions.setInvLogbookLoading(true));
        try {
            const response = await axios.get(`${API_URL}/api/invoice/invoiceProfile/invoiceLogBook`);
            dispatch(slice.actions.setInvoiceLogbookData(response.data.data));
            dispatch(slice.actions.setInvLogbookLoading(false));
        } catch (error) {
            console.error(error);
            dispatch(slice.actions.hasError(error));
            dispatch(slice.actions.setInvLogbookLoading(false));
        }
    };
}

export function getCurrentInvNum() {
    const API_URL = process.env.REACT_APP_API_URL;
    return async () => {
        try {
            const response = await axios.get(`${API_URL}/api/Admin/Invoice/currentInvoiceNum`);
            dispatch(slice.actions.setInvoiceNum(response.data.data));
        } catch (error) {
            console.error(error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getBillingForecast(Year) {
    const API_URL = process.env.REACT_APP_API_URL;
    return async () => {
        try {
            // Fetch selected year and sentinel-year (2099) in parallel so we can append
            // Unscheduled (Nov 2099) and On Hold (Dec 2099) bars to the chart
            const [yearRes, sentinelRes] = await Promise.all([
                axios.get(`${API_URL}/api/invoicing/billing_forecast?Year=${Year}`),
                axios.get(`${API_URL}/api/invoicing/billing_forecast?Year=2099`)
            ]);

            const yearData = Array.isArray(yearRes.data?.data) ? yearRes.data.data : [];
            const sentinelData = Array.isArray(sentinelRes.data?.data) ? sentinelRes.data.data : [];

            const norm = (m) => (m || '').toString().toLowerCase().slice(0, 3);
            const findMonth = (arr, key) => arr.find((x) => norm(x?.month) === key) || { planned: 0, invoiced: 0 };

            const unscheduled = findMonth(sentinelData, 'nov');
            const onHold = findMonth(sentinelData, 'dec');

            const merged = [
                ...yearData,
                { month: 'Unscheduled', planned: Number(unscheduled.planned || 0), invoiced: Number(unscheduled.invoiced || 0) },
                { month: 'On Hold', planned: Number(onHold.planned || 0), invoiced: Number(onHold.invoiced || 0) },
            ];

            dispatch(slice.actions.setBillingForecast(merged));
        } catch (error) {
            console.error(error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function postInvoiceNumUnpaid(InvoiceNumber, SubmittedBy) {
    const API_URL = process.env.REACT_APP_API_URL;
    return async () => {
        try {
            const response = await axios.post(
                `${API_URL}/api/Admin/Invoice/unpaidReset`,
                {
                    InvoiceNumber,
                    SubmittedBy
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            dispatch(slice.actions.setShowSuccess(true));
        } catch (error) {
            console.error(error);
            dispatch(slice.actions.setShowSuccess(false));
            dispatch(slice.actions.hasErrorNum(error));
        }
    };
}

export function postInvoiceNum(InvoiceNumber) {
    const API_URL = process.env.REACT_APP_API_URL;
    return async () => {
        try {
            const response = await axios.post(`${API_URL}/api/Admin/Invoice/updateInvoiceNum`,
                InvoiceNumber, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            dispatch(slice.actions.setInvoiceNum(response.data.data));
            dispatch(slice.actions.setShowSuccess(true));
        } catch (error) {
            console.error(error);
            dispatch(slice.actions.setShowSuccess(false));
            dispatch(slice.actions.hasErrorNum(error));
        }
    };
}

export function postLogBook(invoiceID, status, activity, comment, user_email) {
    const API_URL = process.env.REACT_APP_API_URL;

    const CommentLog = {
        invoiceID,
        status,
        activity,
        comment,
        email: user_email,
    };

    return async () => {
        dispatch(slice.actions.setInvLogbookLoading(true));
        // NOTE TO HASSAN: Potentially include other loading variables to true for the invoice profile page
        try {
            const response = await axios.post(`${API_URL}/api/invoice/invoiceProfile/submitInvoiceLogbook`,
                CommentLog, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            // If the logbook submission was successful and status is "paid", refresh the main invoicing page data
            if (status?.toLowerCase() === 'paid') {
                // Refresh the main invoicing page data with default values
                const currentYear = new Date().getFullYear();
                const defaultSelectedMonth = 'This Month';
                dispatch(getInvSummaryTable(defaultSelectedMonth));
                dispatch(getInvSummaryCards(defaultSelectedMonth));
                dispatch(getBillingForecast(currentYear));
            }

            dispatch(slice.actions.setInvLogbookLoading(false));
            dispatch(getLogBook());

        } catch (error) {
            console.error(error);
            dispatch(slice.actions.hasError(error));
            dispatch(slice.actions.setInvLogbookLoading(false));
            dispatch(getLogBook());
            // NOTE TO HASSAN: Potentially include other loading variables to false for the invoice profile page
            // RELOAD ALL DATA for the page, call other APIs present in the page
        }
    };
}

export function getLogBookFilters() {
    const API_URL = process.env.REACT_APP_API_URL;
    return async () => {
        try {
            const response = await axios.get(`${API_URL}/api/invoice/invoiceProfile/LogBookFilters`);
            dispatch(slice.actions.setInvoiceLogbookFilters(response.data.data));
        } catch (error) {
            console.error(error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function fetchInvoiceExport() {
    const API_URL = process.env.REACT_APP_API_URL;
    return async (dispatch) => {
        try {
            // Make an API call to request the invoice data in CSV format
            const response = await axios.get(`${API_URL}/api/export/invoices`, {
                responseType: 'blob',  // Setting responseType to 'blob' to handle binary data.
            });

            // Create a Blob object from the response data
            const file = new Blob([response.data], { type: 'text/csv' });

            // Generate a URL for the Blob object
            const fileURL = URL.createObjectURL(file);

            // Create a temporary anchor element to enable file download
            const tempLink = document.createElement('a');
            tempLink.href = fileURL;
            tempLink.setAttribute('download', 'Billing Data.csv'); // Setting the default file name for CSV
            tempLink.style.display = 'none';
            document.body.appendChild(tempLink);
            tempLink.click(); // Trigger the download
            document.body.removeChild(tempLink);

            // Revoke the Blob URL to free up resources
            URL.revokeObjectURL(fileURL);

            // Dispatch a success action, could update state to show download was successful
            dispatch({ type: 'DOWNLOAD_SUCCESS' });
        } catch (error) {
            // Log error if the export process fails and dispatch an error state update
            console.error('Error during export:', error);
            dispatch({ type: 'DOWNLOAD_ERROR', error });
        }
    };
}


export function fetchKFInvoiceExport() {
    const API_URL = process.env.REACT_APP_API_URL;
    return async (dispatch) => {
        try {
            // Make an API call to request the invoice data in CSV format
            const response = await axios.get(`${API_URL}/api/export/kashflow/invoice`, {
                responseType: 'blob',  // Setting responseType to 'blob' to handle binary data.
            });

            // Create a Blob object from the response data
            const file = new Blob([response.data], { type: 'text/csv' });

            // Generate a URL for the Blob object
            const fileURL = URL.createObjectURL(file);

            // Create a temporary anchor element to enable file download
            const tempLink = document.createElement('a');
            tempLink.href = fileURL;
            tempLink.setAttribute('download', 'KF Invoice Data.csv'); // Setting the default file name for CSV
            tempLink.style.display = 'none';
            document.body.appendChild(tempLink);
            tempLink.click(); // Trigger the download
            document.body.removeChild(tempLink);

            // Revoke the Blob URL to free up resources
            URL.revokeObjectURL(fileURL);

            // Dispatch a success action, could update state to show download was successful
            dispatch({ type: 'DOWNLOAD_SUCCESS' });
        } catch (error) {
            // Log error if the export process fails and dispatch an error state update
            console.error('Error during export:', error);
            dispatch({ type: 'DOWNLOAD_ERROR', error });
        }
    };
}

export function fetchKFPaidExport() {
    const API_URL = process.env.REACT_APP_API_URL;
    return async (dispatch) => {
        try {
            // Make an API call to request the invoice data in CSV format
            const response = await axios.get(`${API_URL}/api/export/kashflow/paid`, {
                responseType: 'blob',  // Setting responseType to 'blob' to handle binary data.
            });

            // Create a Blob object from the response data
            const file = new Blob([response.data], { type: 'text/csv' });

            // Generate a URL for the Blob object
            const fileURL = URL.createObjectURL(file);

            // Create a temporary anchor element to enable file download
            const tempLink = document.createElement('a');
            tempLink.href = fileURL;
            tempLink.setAttribute('download', 'KF Paid Data.csv'); // Setting the default file name for CSV
            tempLink.style.display = 'none';
            document.body.appendChild(tempLink);
            tempLink.click(); // Trigger the download
            document.body.removeChild(tempLink);

            // Revoke the Blob URL to free up resources
            URL.revokeObjectURL(fileURL);

            // Dispatch a success action, could update state to show download was successful
            dispatch({ type: 'DOWNLOAD_SUCCESS' });
        } catch (error) {
            // Log error if the export process fails and dispatch an error state update
            console.error('Error during export:', error);
            dispatch({ type: 'DOWNLOAD_ERROR', error });
        }
    };
}

export function fetchMonthBillBreakdownExport() {
    const API_URL = process.env.REACT_APP_API_URL;
    return async (dispatch) => {
        try {
            // Make an API call to request the invoice data in CSV format
            const response = await axios.get(`${API_URL}/api/export/invoices/monthlybilling`, {
                responseType: 'blob',  // Setting responseType to 'blob' to handle binary data.
            });

            // Create a Blob object from the response data
            const file = new Blob([response.data], { type: 'text/csv' });

            // Generate a URL for the Blob object
            const fileURL = URL.createObjectURL(file);

            // Create a temporary anchor element to enable file download
            const tempLink = document.createElement('a');
            tempLink.href = fileURL;
            tempLink.setAttribute('download', 'Billing Breakdown.csv'); // Setting the default file name for CSV
            tempLink.style.display = 'none';
            document.body.appendChild(tempLink);
            tempLink.click(); // Trigger the download
            document.body.removeChild(tempLink);

            // Revoke the Blob URL to free up resources
            URL.revokeObjectURL(fileURL);

            // Dispatch a success action, could update state to show download was successful
            dispatch({ type: 'DOWNLOAD_SUCCESS' });
        } catch (error) {
            // Log error if the export process fails and dispatch an error state update
            console.error('Error during export:', error);
            dispatch({ type: 'DOWNLOAD_ERROR', error });
        }
    };
}

// VAULTED
export function fetchBillingPlanExport() {
    const API_URL = process.env.REACT_APP_API_URL;
    return async (dispatch) => {
        try {
            // Make an API call to request the billing plan data in CSV format
            const response = await axios.get(`${API_URL}/api/export/billing_plans`, {
                responseType: 'blob',  // Setting responseType to 'blob' to handle binary data.
            });

            // Create a Blob object from the response data
            const file = new Blob([response.data], { type: 'text/csv' });

            // Generate a URL for the Blob object
            const fileURL = URL.createObjectURL(file);

            // Create a temporary anchor element to enable file download
            const tempLink = document.createElement('a');
            tempLink.href = fileURL;
            tempLink.setAttribute('download', 'Billing Plans.csv'); // Setting the default file name for CSV
            tempLink.style.display = 'none';
            document.body.appendChild(tempLink);
            tempLink.click(); // Trigger the download
            document.body.removeChild(tempLink);

            // Revoke the Blob URL to free up resources
            URL.revokeObjectURL(fileURL);

            // Dispatch a success action, could update state to show download was successful
            dispatch({ type: 'DOWNLOAD_SUCCESS' });
        } catch (error) {
            // Log error if the export process fails and dispatch an error state update
            console.error('Error during export:', error);
            dispatch({ type: 'DOWNLOAD_ERROR', error });
        }
    };
}


export default slice.reducer;
